<template>
    <v-dialog 
        v-model="this.show" 
        :persistent="this.isPersistent" 
        @click:outside="this.isPersistent ? actionPerformed(false) : null"
        width="350px">
        <v-card>
            <v-card-title>
                {{ this.title }}
            </v-card-title>
                <v-card-text>
                    {{ this.message }}
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click="actionPerformed(false)"
                >
                    {{ this.negativeActionButtonText }}
                </v-btn>
                <v-btn
                    color="primary"
                    @click="actionPerformed(true)"
                >
                    {{ this.positiveActionButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> 
</template>
<script>

export default {
    name: 'ConfirmDialog',
    props: {
        confirmDialogOptions: {
            type: Object,
            default: {
                title: {
                    type: String,
                    default: '',
                    required: false
                },
                message: {
                    type: String,
                    default: '',
                    required: false
                },
                positiveActionButtonText: {
                    type: String,
                    default: '',
                    required: false
                },
                negativeActionButtonText: {
                    type: String,
                    default: '',
                    required: false
                },
                isPersistent: {
                    type: Boolean,
                    default: true,
                    required: false
                },
                visible:{
                    type: Boolean,
                    default: false,
                    required: true
                }
            }
        }
    },
    data() {
        return {
            confirmed: false,
            title: '',
            message: '',
            positiveActionButtonText: '',
            negativeActionButtonText: '',
            isPersistent: false,
            visible:false
        };
    },
    methods: {
        actionPerformed(confirmed){
            this.confirmed = confirmed;
            this.show = false;
        },
        translate(text) {
            if (this.$i18n.locale == 'en')
                return this.$i18n._getMessages().en[text] == null ? text : this.$i18n._getMessages().en[text]
            else
                return this.$i18n._getMessages().ar[text] == null ? text : this.$i18n._getMessages().ar[text]
        },
        setOptions() {
            this.visible = this.confirmDialogOptions.visible;
            if(this.confirmDialogOptions.isPersistent){
                this.isPersistent = this.confirmDialogOptions.isPersistent;
            } else {
                this.isPersistent = false;
            }

            if (this.confirmDialogOptions.title && this.confirmDialogOptions.title != ''){
                this.title = this.confirmDialogOptions.title;
            } else {
                this.title = translate("res_Label_makeSelection");
            }

            if (this.confirmDialogOptions.message && this.confirmDialogOptions.message != ''){
                this.message = this.confirmDialogOptions.message;
            } else {
                this.message=translate("res_Msgs_genericConfirmationAlert");
            }

            if (this.confirmDialogOptions.positiveActionButtonText && this.confirmDialogOptions.positiveActionButtonText != ''){
                this.positiveActionButtonText = this.confirmDialogOptions.positiveActionButtonText;
            } else {
                this.positiveActionButtonText=translate("res_ButtonText_Yes");
            }

            if (this.confirmDialogOptions.negativeActionButtonText && this.confirmDialogOptions.negativeActionButtonText != ''){
                this.negativeActionButtonText = this.confirmDialogOptions.negativeActionButtonText;
            } else {
                this.negativeActionButtonText=translate("res_ButtonText_No");
            }
        }
    },
    mounted() 
    {
        this.setOptions();
        
    },
    watch:{
        confirmDialogOptions: {
            handler(newVal, oldVal){
                this.setOptions();
            },
            deep: true
        }
    },
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                  this.$emit('actionPerformed', {
                    confirmed: this.confirmed
                  });
                }
            }
        }
    }
}
</script>

<style scoped>
    .overflow-auto {
        overflow-y: auto;
    }
</style>